<div class="search-row" [hidden]="currentPage() === 'impacter'">
  <app-filter-text-and-items
    [itemsSectionName]="'thèmes'"
    [items]="topics"
    [placeholder]="'search.search-placeholder' | translate"
    (itemSelect)="topicSearch($event)"
    (textSelect)="textSearch($event)"
    (clearChange)="resetSearch()"
  >
    <ng-template #leftIconTemplate>
      <i class="ph-fill ph-chat-circle-text search-icon"></i>
    </ng-template>
  </app-filter-text-and-items>
  <ex-sort-dropdown [items]="sortOptions" (sort)="sortSelect($event)" [defaultValue]="defaultSort" useShortLabel />
</div>
<ex-filter-text
  variant="light"
  (textEnter)="textSearch($event)"
  [hidden]="currentPage() !== 'impacter'"
  [placeholder]="'search.search-placeholder-impacter' | translate"
>
  <ng-template #leftIconTemplate>
    <i class="ph-fill ph-user search-icon"></i>
  </ng-template>
</ex-filter-text>
